import { Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs';

import { UnsavedChangesPromptService } from '@core/services/unsaved-changes/unsaved-changes-prompt.service';

import {
  ModalComponent,
  ModalConfig,
  ModalType
} from '@shared/components/modal/modal.component';

@Component({
  selector: 'app-unsaved-changes-dialog',
  imports: [ModalComponent, TranslatePipe],
  templateUrl: './unsaved-changes-dialog.component.html'
})
export class UnsavedChangesDialogComponent {
  protected readonly prompt = inject(UnsavedChangesPromptService);
  private readonly translate = inject(TranslateService);
  private readonly lang = toSignal(
    this.translate.onLangChange.pipe(map((event) => event.lang)),
    { initialValue: this.translate.getCurrentLang() }
  );

  protected readonly config = computed<ModalConfig>(() => {
    this.lang();
    return {
      icon: 'warning',
      type: ModalType.WARNING,
      dismissible: true,
      closeOnBackdropClick: true,
      askingModal: true,
      actions: [
        {
          label: this.translate.instant('common.unsaved_changes.stay'),
          callback: () => this.prompt.answer(false),
          color: 'cancel'
        },
        {
          label: this.translate.instant('common.unsaved_changes.leave'),
          callback: () => this.prompt.answer(true),
          color: ModalType.ERROR
        }
      ]
    };
  });
}
